<template>
    <main>
        <Banner :info="bannerInfo" />
        <Eq />
        <Video ytId="qHYYKmbHoO8" />
        <div id="auto">
            <Ad v-for="(info,i) in autoInfo"  :info="info" :key="i"/>
        </div>

    </main>
</template>

<script>
import Banner from '@/components/Banner'
import Eq from './_eq.vue'
import Video from '@/components/Video'
import Ad from './_ad.vue'

export default {
    components: {Banner, Eq, Video, Ad},
    data() {
        return {
            bannerInfo: {
                src: require("@/assets/images/production/banner.jpg"),
                alt: "wipe clear explore more"
            },
            autoInfo: [
                {
                    "title": "Automatic Storage System",
                    "bg": "url(" + require("@/assets/images/production/auto-bg-1.jpg") + ")",
                    "items": [
                        {'img': require('@/assets/images/production/auto-1.png'), "desc": ["- First-in-first-out management and reduce handling costs", "- Improve storage environment"]},
                        {'img': require('@/assets/images/production/auto-2.png'), "desc": ["- Analyze Product data together with QAD system and Barcode system"]},
                        {'img': require('@/assets/images/production/auto-3.png'), "desc": ["- Intelligent product storage to reduce misplacement"]}
                    ]
                },
                {
                    "title": "Automatic assembly machine",
                    "bg": "url(" + require("@/assets/images/production/auto-bg-2.jpg") + ")",
                    "items": [
                        {'img': require('@/assets/images/production/auto-4.png'), "desc": ["- Reduce labor costs and improve product stability"]},
                        {'img': require('@/assets/images/production/auto-5.png'), "desc": ["- Assembling tray with free flow transportaion"]},
                        {'img': require('@/assets/images/production/auto-6.png'), "desc": ["- Intelligent CCD visual inspection system", "- Independent research and development to maximize production capacity"]}
                    ]
                }
            ]
        }
    },
}
</script>
